import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuditEventSearchRequestDto } from '../interfaces/audit-event-search-request-dto';
import { AuditEventDto } from '../interfaces/audit-event-dto';
import { PaginatedSearchResponse } from '../interfaces/paginated-search-response';
import { envToken } from '../tokens/env-token';

@Injectable({
    providedIn: 'root'
})
export class AuditEventSearchService {
    private http = inject(HttpClient);
    private env = inject(envToken);


    baseUrl = '';

    constructor() {
        this.baseUrl = this.env.apiUrl + '/api/v1/audit-event';
    }

    getAuditEvents(sourceSystem: string, searchRequest: AuditEventSearchRequestDto): Observable<PaginatedSearchResponse<AuditEventDto>> {
        return this.http.post<PaginatedSearchResponse<AuditEventDto>>(`${ this.baseUrl }/${ sourceSystem }`, searchRequest);
    }
}
